var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBitcoinOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9094 18.6706C23.2749 18.5921 24.5594 17.9976 25.5029 17.0073C26.4463 16.0171 26.978 14.7053 26.9903 13.3376C27.0026 11.97 26.4946 10.6488 25.5691 9.64183C24.6436 8.6348 23.3699 8.01725 22.0061 7.91428H13.6912C13.1719 7.91428 12.6739 8.12056 12.3067 8.48772C11.9396 8.85491 11.7333 9.35289 11.7333 9.87216V29.4268C11.7333 29.9461 11.9396 30.4442 12.3067 30.8114C12.6739 31.1786 13.1719 31.3847 13.6912 31.3847H21.9094C23.5955 31.3847 25.2124 30.7149 26.4046 29.5228C27.5968 28.3307 28.2666 26.7137 28.2666 25.0276C28.2666 23.3416 27.5968 21.7247 26.4046 20.5325C25.2124 19.3403 23.5955 18.6706 21.9094 18.6706Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4799 7.91429V4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5228 7.91429V4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4799 35.7114V31.3847",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5228 35.7114V31.3847",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0061 18.6704H11.7333",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBitcoinOutline);
export default __webpack_public_path__ + "static/media/icon_bitcoin_outline.59814e3fc2efcc38aca84d73e1967b0d.svg";
export { ForwardRef as ReactComponent };